import "core-js/modules/es.array.concat.js";
import { getReq } from './axios';
import { relifExportParams } from './models';
var BASE_URL = "".concat(apiUrl, "/relif-export");
export var getRelifExports = function getRelifExports() {
  return getReq(BASE_URL);
};
export var getRelifExport = function getRelifExport(id) {
  return getReq("".concat(BASE_URL, "/").concat(id, "/download"), {
    responseType: 'blob'
  });
};
export var getRelifBorrower = function getRelifBorrower(params) {
  return getReq("".concat(BASE_URL, "/borrowers"), {
    params: relifExportParams(params)
  });
};
export var exportRelifBorrower = function exportRelifBorrower(params) {
  return getReq("".concat(BASE_URL, "/borrowers"), {
    params: relifExportParams(params),
    responseType: 'blob'
  });
};